import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
	/* eslint-disable no-param-reassign */

	name: 'notification',
	initialState: {
		type: '',
		message: ''
	},
	reducers: {
		setType: (state, action) => {
			state.type = action.payload;
		},
		setMessage: (state, action) => {
			state.message = action.payload;
		},
		hideNotification: (state) => {
			state.type = '';
			state.message = '';
		}
	}
});

export const { hideNotification } = slice.actions;

export const showNotification = (type, message) => (dispatch) => {
	dispatch(slice.actions.setType(type));
	dispatch(slice.actions.setMessage(message));
};

export const notification = (state) => state.notification;

export default slice.reducer;
